import * as Yup from "yup";
import checkout from "layouts/organization/components/organization-details/schemas/organizationForm";

const {
  formField: { organizationKey, isPhonicsEnabled },
} = checkout;

export default {
  validation: Yup.object().shape({
    [organizationKey.name]: Yup.string().required(organizationKey.errorMsg),
    [isPhonicsEnabled.name]: Yup.boolean(),
  }),
};
